/* import __COLOCATED_TEMPLATE__ from './health-check.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();